import { Component, ViewChild, ElementRef, HostListener, OnInit, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';

import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';

import { ConfigService } from './core/services/config.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  open: boolean = false;
  // some fields to store our state so we can display it in the UI
  idleState = "NOT_STARTED";
  currentUrl: any;
  countdown?: number = null;
  lastPing?: Date = null;
  userClosedCookie: string = localStorage.getItem('userClosedCookie');
  isHideDrawer: boolean;
  innerWidth: number;

  constructor(
    private idle: Idle,
    private keepalive: Keepalive,
    private cd: ChangeDetectorRef,
    private router: Router,
    private config: ConfigService
  ) {
    // set idle parameters
    idle.setIdle(!!this.config?.configuration?.idletime ? Number(this.config.configuration.idletime) : 1800); // will consider idle state start after given seconds. i.e 5 seconds
    idle.setTimeout(!!this.config?.configuration?.timeout_countdown ? Number(this.config.configuration.timeout_countdown) : 10); // After idle state started, countdown for given seconds to timeout. 
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES); // provide sources that will "interrupt" aka provide events indicating the user is active

    // On Idle state starting
    idle.onIdleStart.subscribe(() => {
      // this.currentUrl = this.router.url;
      this.idleState = "IDLE";
    });

    // On Idle state ended
    idle.onIdleEnd.subscribe(() => {
      this.idleState = "NOT_IDLE";
      this.countdown = null;
      cd.detectChanges(); // how do i avoid this kludge?
    });

    //
    idle.onTimeout.subscribe(() => {
      this.idleState = "TIMED_OUT";
      window.location.reload();
    });

    // do something as the timeout countdown does its thing
    idle.onTimeoutWarning.subscribe(seconds => {
      this.countdown = seconds;
    });

    // set keepalive parameters, omit if not using keepalive
    keepalive.interval(!!this.config?.configuration?.timeout_countdown ? Number(this.config?.configuration?.timeout_countdown) : 10); // will ping at this interval while not idle, in seconds
    keepalive.onPing.subscribe(() => {
      this.lastPing = new Date();
    });
  }

  reset() {
    // we'll call this method when we want to start/reset the idle process
    // reset any component state and be sure to call idle.watch()
    this.idle.watch();
    this.idleState = "NOT_IDLE";
    this.countdown = null;
    this.lastPing = null;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    if (event.target.innerWidth >= 992) {
      this.isHideDrawer = true;
    } else {
      this.isHideDrawer = false;
    }
  }

  ngOnInit(): void {
    if (window.innerWidth >= 992) {
      this.isHideDrawer = true;
    } else {
      this.isHideDrawer = false;
    }
    this.reset();
  }

  @ViewChild('drawer', { static: false }) drawer: ElementRef

  // Close privacy policy
  closePrivacyPolicy() {
    localStorage.setItem('userClosedCookie', 'true');
    this.userClosedCookie = 'true';
  }

  // Event from child
  eventFromChild(eve) {
    this.open = !this.open
  }

  // Event from drawer
  onOpenedChange(e) {
    if (!e) { this.open = false }
  }
}